var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "homepage flow" },
    [
      _c("ehr-navigation", { attrs: { "active-item": "home" } }),
      _vm._v(" "),
      _c("h1", [_vm._v(_vm._s(_vm.applicationName) + "!")]),
      _vm._v(" "),
      _c("div", [
        _c(
          "nav",
          { staticClass: "modules-and-tiles wrapper" },
          [
            _vm._l(_vm.modules, function(module) {
              return _c("section-card", {
                key: module.path,
                attrs: {
                  "card-title": module.name,
                  "card-icon": module.fontAwesomeIcon,
                  destination: module.path
                }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.tiles, function(tile) {
              return _c("section-card", {
                key: tile.url,
                attrs: {
                  "card-title": tile.name,
                  destination: tile.url,
                  "is-external": ""
                }
              })
            })
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }